"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var styles = require('./MessageAdListItem.scss');
var classNames = require('classnames/bind').bind(styles);
var SingleLineViewPreviewLine = /** @class */ (function (_super) {
    tslib_1.__extends(SingleLineViewPreviewLine, _super);
    function SingleLineViewPreviewLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SingleLineViewPreviewLine.prototype.render = function () {
        return (React.createElement("div", { className: classNames(styles.previewDisplaySingleLine, 'fbAdBody', 'fbAdLink') }, this.props.previewTexts));
    };
    SingleLineViewPreviewLine = tslib_1.__decorate([
        mobx_react_1.observer
    ], SingleLineViewPreviewLine);
    return SingleLineViewPreviewLine;
}(React.Component));
exports.default = SingleLineViewPreviewLine;
//# sourceMappingURL=SingleLineViewPreviewLine.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/components/SingleLineViewPreviewLine.js
// module id = 6000
// module chunks = 67